export const pendingAssignedSeatSelectionStorageKey = (eventId?: string) =>
  `event-assigned-seats-${eventId || ""}`;

import {
  AssignedSeatingMap,
  recoverAssignedSeatSelection,
} from "./assignedSeating";

export const normalizePendingAssignedSeatKeys = (value: unknown) => {
  if (!Array.isArray(value)) {
    return [];
  }

  return Array.from(
    new Set(
      value.filter(
        (seatKey): seatKey is string =>
          typeof seatKey === "string" && Boolean(seatKey)
      )
    )
  );
};

export const restorePendingAssignedSeatSelection = ({
  seatMap,
  pendingSeatKeys,
}: {
  seatMap?: AssignedSeatingMap | null;
  pendingSeatKeys: unknown;
}) =>
  recoverAssignedSeatSelection({
    seatMap,
    selectedSeatKeys: normalizePendingAssignedSeatKeys(pendingSeatKeys),
  });
